import { Helmet } from "react-helmet";

interface MetaDataProps {
  title?: string;
  description?: string;
  keywords?: string;
  url?: string;
  image?: string;
  type?: string;
  structuredData?: object;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

const MetaData = ({
  title = "Nova Creations - Professional Minecraft Building Services",
  description = "At NovaCreations, we specialize in creating everything from cozy houses to expansive projects and custom maps. With nearly a decade of experience, our team is dedicated to delivering top-tier quality!",
  keywords = "minecraft builds, minecraft building services, custom minecraft maps, minecraft houses, minecraft castles, minecraft terrain, professional minecraft builders",
  url = "https://www.novacreations.site",
  image = "https://i.imgur.com/qsv10H9.png",
  type = "website",
  structuredData,
  author = "Nova Creations",
  publishedTime,
  modifiedTime,
}: MetaDataProps) => {
  const siteName = "Nova Creations";
  const twitterHandle = "@novacreations";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang="en" />
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
      <link rel="canonical" href={url} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={`${siteName} - ${title}`} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={`${siteName} - ${title}`} />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:creator" content={twitterHandle} />

      {/* Additional SEO Meta Tags */}
      <meta name="theme-color" content="#06b6d4" />
      <meta name="msapplication-TileColor" content="#06b6d4" />
      <meta name="application-name" content={siteName} />

      {/* Performance & Resource Hints */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link rel="preconnect" href="https://res.cloudinary.com" />
      <link rel="dns-prefetch" href="https://i.imgur.com" />

      {/* Favicon and Icons */}
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="https://i.imgur.com/qsv10H9.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="https://i.imgur.com/qsv10H9.png"
      />
      <link rel="apple-touch-icon" href="https://i.imgur.com/qsv10H9.png" />
      <link
        rel="shortcut icon"
        href="https://i.imgur.com/qsv10H9.png"
        type="image/x-icon"
      />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default MetaData;
